import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    containerStyle,
    formContainerStyle,
    headerStyle,
    titleStyle,
    formStyle,
    buttonStyle,
    footerTextStyle
} from '../styles/globalStyles';

const CheckoutSuccess: React.FC = () => {
    const navigate = useNavigate();
    const [ searchParams ] = useSearchParams();
    const sessionId = searchParams.get( 'session_id' );

    return(
        <div style={containerStyle}>
            <div style={formContainerStyle}>
                <div style={headerStyle}>
                    <h1 style={titleStyle}>Subscription Started</h1>
                </div>
                <div style={formStyle}>
                    <div style={{ color: '#22d3ee', textAlign: 'center' }}>
                        Your checkout was successful.
                    </div>
                    {sessionId && (
                        <div style={{ ...footerTextStyle, marginTop: 12 }}>
                            Session ID: {sessionId}
                        </div>
                    )}
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginTop: 24 }}>
                        <button type="button" style={buttonStyle} onClick={() => navigate( '/dashboard' )}>
                            Go to Dashboard
                        </button>
                        <button
                            type="button"
                            style={{ ...buttonStyle, background: 'transparent', border: '1px solid #22d3ee', color: '#22d3ee' }}
                            onClick={() => navigate( '/' )}
                        >
                            Back to Home
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CheckoutSuccess;
